import React from "react";
import Alert from "@mui/material/Alert";
import { Helmet } from "react-helmet-async";
import { Navigate, useSearchParams } from "react-router";
import LayoutProtectedRoutes from "@/src/containers/Layouts/LayoutProtectedRoutes";
import LegalbirdAuthenticatedLoaderPage from "@/src/containers/Pages/Loading/LegalbirdAuthenticatedLoaderPage";
import MessageCenter from "@/src/components/Messaging/MessageCenter/MessageCenter";
import EmailVerificationModal from "@/src/components/FormInfoModal/EmailVerificationModal";
import { useBasicAccountData } from "@/src/provider/BasicAccountData/BasicAccountDataProvider";

export default function MessageCenterPage() {
  const { minimalCases, conversations, isLoading, isError } = useBasicAccountData();

  const [searchParams] = useSearchParams();
  const caseIdFromQuery = searchParams.get("caseId");

  if (isLoading) {
    return <LegalbirdAuthenticatedLoaderPage />;
  }

  if (isError || !minimalCases || !conversations) {
    return (
      <LayoutProtectedRoutes>
        <Alert severity={"error"}>Die Nachrichten konnten nicht geladen werden. Bitte versuchen Sie es später erneut.</Alert>
      </LayoutProtectedRoutes>
    );
  }

  // fallback for old new-message-notification button links ?caseId=.
  const linkedCase = minimalCases.find((minimalCase) => String(minimalCase.id) === caseIdFromQuery);
  if (linkedCase) {
    return <Navigate to={`/servicewelt/nachrichten/fall/${linkedCase.id}`} replace />;
  }

  return (
    <LayoutProtectedRoutes>
      <Helmet>
        <title>Servicewelt Nachrichtenübersicht | Legalbird</title>
      </Helmet>
      <MessageCenter minimalCases={minimalCases} conversations={conversations} />
      <EmailVerificationModal />
    </LayoutProtectedRoutes>
  );
}
